import { PageProps } from 'gatsby';
import React from 'react';
import GlobalMain from '../molecules/Main/GlobalMain';
import HeroBanner from 'sections/ProductOverview/HeroBanner/HeroBanner';
import PeopleMagicAdvertisement from 'sections/ProductOverview/PeopleMagicAdvertisement/PeopleMagicAdvertisement';
import GrowthComesNaturally from 'sections/ProductOverview/GrowthComesNaturally/GrowthComesNaturally';
import YourOwnBrandedApps from 'sections/ProductOverview/YourOwnBrandedApps/YourOwnBrandedApps';
import Pricing from 'sections/ProductOverview/Pricing/Pricing';
import WhyCreatorsChooseMighty from 'sections/ProductOverview/SenjaReviews/SenjaReviews';
import CallToAction from 'sections/ProductOverview/CallToAction/CallToAction';

const ProductOverviewView = (props: PageProps): JSX.Element => {
  return (
    <GlobalMain location={props.location}>
      <HeroBanner />
      <GrowthComesNaturally />
      <YourOwnBrandedApps />
      <PeopleMagicAdvertisement />
      <CallToAction />
      <Pricing />
      <WhyCreatorsChooseMighty />
    </GlobalMain>
  );
};

export default ProductOverviewView;
